/*
 * Author: Harper Yan
 * File Created: Tuesday, 24-07-23 10:47 am
 * Last Modified: Monday, 24-11-18 03:13 pm, by Dw
 */

import { css } from '@emotion/react';

export const globalStyles = css`
    html, body {
        height: 100%;
        overflow: auto;
    }

    @font-face {
        font-family: 'Arabellia_Signature';
        src: url("${process.env.NEXT_PUBLIC_PREFIX_PATH}/fonts/Arabellia_Signature.otf") format('opentype');
        font-weight: normal;
        font-style: normal;
    }

    @font-face {
        font-family: 'PingFang SC';
        font-weight: 400;
        src: local('PingFang SC Regular'), local('PingFang SC-Regular');
    }

    @font-face {
        font-family: 'PingFang SC';
        font-weight: 500;
        src: local('PingFang SC Medium'), local('PingFang SC-Medium');
    }

    /* Class-based approach */
    .page-main {
        font-family: 'Inter', sans-serif; /* Default to Inter for English */
    }

    .page-main :lang(zh) {
        font-family: 'PingFang SC', sans-serif;
    }

    a {
        text-decoration: none;
    }

    a:active, a:hover {
        color: #A993FF;
    },

    a.primary {
        color: #A993FF;
    }

    a.white {
        color: #FFF;
    }

    /* Only apply hover styles for non-touch devices */
    @media (hover: hover) and (pointer: fine) {
        a:hover {
         color: #A993FF
        },
    },

    /* Optionally define styles for active state on touch devices */
    @media (hover: none) and (pointer: coarse) {
        &:active {
            color: #A993FF
        },
  },

    ::-webkit-scrollbar {
        width: 0px;
        height: 0px;
    }

    ::-webkit-scrollbar-track {
        background: transparent; /* 背景色 */
    }

    ::-webkit-scrollbar-thumb {
        background-color: #4F5867; /* 滑块颜色 */
        opacity: 0.5;
    }

    input:-webkit-autofill,
    textarea:-webkit-autofill,
    input:-webkit-autofill:active
    input:-webkit-autofill:hover
    select:-webkit-autofill {
        -webkit-box-shadow: 0 0 0 1000px #252837 inset !important; /* 设置背景色 */
        border-radius: '2px',
        -webkit-text-fill-color: #000; /* 设置文本颜色 */
        transition: background-color 5000s ease-in-out 0s; /* 防止背景色在失去焦点后立即恢复 */
    }

`;
